export default __webpack_public_path__ + "static/N0236-638b000d75abf73ba889b8d081b76e64.png";